angular.module('impactx').service('OpenIdService', [
    OpenIdService]);

function OpenIdService() {

    this.lastOpenIdParams = {};

    this.setLastOpenIdParams = function (params) {
        this.lastOpenIdParams = params;
    };

    this.getLastOpenIdParams = function () {
        return this.lastOpenIdParams;
    };


    return {
        getLastOpenIdParams: this.getLastOpenIdParams,
        setLastOpenIdParams: this.setLastOpenIdParams
    };
}